module.exports = __webpack_public_path__ + "static/media/banner-PGL02.fa8c0569.jpg";